import { Inject, Injectable } from "@angular/core";
import { EnvironmentBase, ServiceBase, WebCommunicationService } from "@definitiv-packages/angular-dba-library";
import { PermissionUser, PermissionUserService } from "@definitiv-packages/angular-permissions-library";


@Injectable({
    providedIn: 'root'
})
export class ProjektPermissionService {

    public DebitorLesen: boolean = false;
    public DebitorSchreiben: boolean = false;
    public DebitorLoeschen: boolean = false;

    public ObjektLesen: boolean = false;
    public ObjektSchreiben: boolean = false;
    public ObjektLoeschen: boolean = false;

    public RoofareaLesen: boolean = false;
    public RoofareaSchreiben: boolean = false;
    public RoofareaLoeschen: boolean = false;

    public SafetyPointLesen: boolean = false;
    public SafetyPointSchreiben: boolean = false;
    public SafetyPointLoeschen: boolean = false;

    public serviceLesen: boolean = false;
    public serviceSchreiben: boolean = false;
    public serviceLoeschen: boolean = false;

    public SafetyPointFormSchreiben: boolean = false;
    public SafetyPointFormLesen: boolean = false;
    public SafetyPointFormLoeschen: boolean = false;
    public TodoSchreiben: boolean = false;
    public TodoLesen: boolean = false;
    public TodoLoeschen: boolean = false;    

    public SicherungssystemSchreiben: boolean = false;
    public SicherungssystemLesen: boolean = false;
    public SicherungssystemLoeschen: boolean = false;        

    public StandortSchreiben: boolean = false;
    public StandortLesen: boolean = false;
    public Standortoeschen: boolean = false;       
    constructor(
        private permissionService: PermissionUserService
    ) {
    }

    public async init(): Promise<void> {

        var result = await this.permissionService.GetPermissionUserAll();
  
        this.DebitorLesen = this.getPermission(result, 1);
        this.DebitorSchreiben = this.getPermission(result, 2);
        this.DebitorLoeschen = this.getPermission(result, 3);

        this.ObjektLesen = this.getPermission(result, 4);
        this.ObjektSchreiben = this.getPermission(result, 5);
        this.ObjektLoeschen = this.getPermission(result, 6);

        this.RoofareaLesen = this.getPermission(result, 7);
        this.RoofareaSchreiben = this.getPermission(result, 8);
        this.RoofareaLoeschen = this.getPermission(result, 9);

        this.SafetyPointLesen = this.getPermission(result, 10);
        this.SafetyPointSchreiben = this.getPermission(result, 11);
        this.SafetyPointLoeschen = this.getPermission(result, 12);

        this.serviceLesen = this.getPermission(result, 13);
        this.serviceSchreiben = this.getPermission(result, 14);
        this.serviceLoeschen = this.getPermission(result, 15);
        this.SafetyPointFormLesen = this.getPermission(result, 16);
        this.SafetyPointFormSchreiben = this.getPermission(result, 17);
        this.SafetyPointFormLoeschen = this.getPermission(result, 18);        
        this.TodoLesen = this.getPermission(result, 19);
        this.TodoSchreiben = this.getPermission(result, 20);
        this.TodoLoeschen = this.getPermission(result, 21);        
      
        this.SicherungssystemLesen = this.getPermission(result, 22);
        this.SicherungssystemSchreiben = this.getPermission(result, 23);
        this.SicherungssystemLoeschen = this.getPermission(result, 24);            

        this.SicherungssystemLesen = this.getPermission(result, 22);
        this.SicherungssystemSchreiben = this.getPermission(result, 23);
        this.SicherungssystemLoeschen = this.getPermission(result, 24);            

        this.StandortLesen = this.getPermission(result, 25);
        this.StandortSchreiben = this.getPermission(result, 26);
        this.Standortoeschen = this.getPermission(result, 27);              
    }

    private getPermission(permissons: PermissionUser[], permissionID: number): boolean {
        var x = permissons.find(x => x.PermissionID == permissionID)?.Active;
        return x != null ? x : false;
    }
}
